import _defineProperty from '@babel/runtime/helpers/defineProperty';
import cardTexts from '../Card.texts.js';
import { CardFooter as CardFooter$2, InnerWrapper, InfoScarcity, Description } from './CardFooter.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import useGlobals from '../../../hooks/useGlobals.js';
import useIsGlobetrotter from '../../../hooks/useIsGlobetrotter.js';
import Paragraph from './Paragraph.js';
import ArrowLink from '../../Link/ArrowLink.js';
import PriceSummary from './PriceSummary.js';
import Button from '../../Button/Button.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CardFooter = function CardFooter(_ref) {
  var _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
    _ref$buttonVariant = _ref.buttonVariant,
    buttonVariant = _ref$buttonVariant === void 0 ? 'primary' : _ref$buttonVariant,
    _ref$cardSettings = _ref.cardSettings,
    cardSettings = _ref$cardSettings === void 0 ? null : _ref$cardSettings,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? null : _ref$description,
    _ref$discountDisplayT = _ref.discountDisplayType,
    discountDisplayType = _ref$discountDisplayT === void 0 ? 'original' : _ref$discountDisplayT,
    _ref$onClickPriceDeta = _ref.onClickPriceDetails,
    onClickPriceDetails = _ref$onClickPriceDeta === void 0 ? null : _ref$onClickPriceDeta,
    _ref$originalPrice = _ref.originalPrice,
    originalPrice = _ref$originalPrice === void 0 ? null : _ref$originalPrice,
    _ref$originalPricePer = _ref.originalPricePerPerson,
    originalPricePerPerson = _ref$originalPricePer === void 0 ? null : _ref$originalPricePer,
    _ref$price = _ref.price,
    price = _ref$price === void 0 ? null : _ref$price,
    _ref$pricePerPerson = _ref.pricePerPerson,
    pricePerPerson = _ref$pricePerPerson === void 0 ? null : _ref$pricePerPerson,
    _ref$pricePerPersonFo = _ref.pricePerPersonFocus,
    pricePerPersonFocus = _ref$pricePerPersonFo === void 0 ? false : _ref$pricePerPersonFo,
    _ref$showPriceFromPre = _ref.showPriceFromPrefix,
    showPriceFromPrefix = _ref$showPriceFromPre === void 0 ? false : _ref$showPriceFromPre,
    _ref$scarcityText = _ref.scarcityText,
    scarcityText = _ref$scarcityText === void 0 ? null : _ref$scarcityText,
    _ref$onClickElementPr = _ref.onClickElementProps,
    onClickElementProps = _ref$onClickElementPr === void 0 ? null : _ref$onClickElementPr;
  var _useGlobals = useGlobals(),
    culture = _useGlobals.culture;
  var isGlobetrotter = useIsGlobetrotter();
  return /*#__PURE__*/jsx(CardFooter$2, _objectSpread(_objectSpread({}, cardSettings), {}, {
    $noPriceInfo: !(price || pricePerPerson),
    $noDescription: !description && !onClickPriceDetails,
    children: /*#__PURE__*/jsxs(InnerWrapper, _objectSpread(_objectSpread({}, cardSettings), {}, {
      $noDescription: !description,
      children: [!isGlobetrotter && scarcityText && /*#__PURE__*/jsx(InfoScarcity, {
        children: scarcityText
      }), (description || onClickPriceDetails) && /*#__PURE__*/jsxs(Description, _objectSpread(_objectSpread({}, cardSettings), {}, {
        children: [/*#__PURE__*/jsx(Paragraph, {
          as: typeof description !== 'string' ? 'div' : undefined,
          children: description
        }), onClickPriceDetails && /*#__PURE__*/jsx(ArrowLink, {
          "aria-haspopup": "dialog",
          onClick: onClickPriceDetails
          // @ts-ignore
          ,
          as: "a",
          children: cardTexts[culture].priceDetails
        })]
      })), /*#__PURE__*/jsx(PriceSummary, {
        discountDisplayType: discountDisplayType,
        originalPrice: originalPrice,
        originalPricePerPerson: originalPricePerPerson,
        price: price,
        pricePerPerson: pricePerPerson,
        pricePerPersonFocus: pricePerPersonFocus,
        showPriceFromPrefix: showPriceFromPrefix,
        cardSettings: cardSettings
      }), /*#__PURE__*/jsx(Button, {
        disabled: onClickElementProps === null || onClickElementProps === void 0 ? void 0 : onClickElementProps.disabled,
        size: isGlobetrotter ? 's' : 'm',
        variant: buttonVariant,
        children: buttonText || cardTexts[culture].ctaButton
      })]
    }))
  }));
};
var CardFooter$1 = CardFooter;

export { CardFooter$1 as default };
//# sourceMappingURL=CardFooter.js.map
